/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import SVG from 'react-inlinesvg'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {EnableSidebar} from '../../../_metronic/layout/core'

const JobItem: React.FC = () => {
  const [textFormatting, setTextFormatting] = useState<boolean>(false)

  return (
    <EnableSidebar>
      <div className='mb-0'>
        <Link to={'/job'} className='btn btn-sm btn-light-secondary  px-4 me-2 mb-5'>
          <span className='svg-icon symbol-hover'>
            <SVG src={toAbsoluteUrl('/media/icons/duotune/arrows/arr021.svg')} />
          </span>
          back
        </Link>
        <div className='d-flex align-items-center mb-3'>
          <h1 className='fs-2x fw-bolder text-gray-900 mb-0 me-1'>Senior MERN stack Developer</h1>
          <div className='d-flex align-items-center'>
            <span className='ms-1' data-bs-toggle='tooltip' title='User replied'>
              <KTSVG
                path='media/icons/duotune/general/gen043.svg'
                className='svg-icon-success svg-icon-1'
              />
            </span>
          </div>
        </div>

        <h1 className='my-3 mt-9 fw-normal '>About the position</h1>

        <p>
          A fast-growing online community for members to request and fund their short-term needs is
          looking for a Senior Golang Developer. The developer will join the team in a hands-on role
          with significant research and software development efforts to drive technical decisions
          within the company. The early-stage startup aims at providing non-predatory, simple, and
          community-driven alternatives to short-term loans while building a community that enables
          financial autonomy for all. This is a nice opportunity to join a VC-funded Fintech company
          backed by leading organizations. It requires 4+ hours of overlap with the PST time zone.
        </p>

        <h1 className='my-3 mt-9 fw-normal '>Job Responsibilities:</h1>

        <ul>
          <li>Join the development team to build out the product</li>
          <li>
            Contribute to decisions that align with the product roadmap and growth trajectory of the
            company
          </li>
          <li>
            Work with the engineering team to design a modern, scalable technical architecture
          </li>
          <li>
            Review high level product features for technical feasibility and makes technical
            recommendations
          </li>
          <li>
            Engage in load and performance test applications and identify areas for optimization
            across the entire technology stack
          </li>
          <li>
            Be a mentor to more junior developers by setting development schedules, delegating
            tasks, and reviewing code
          </li>
        </ul>

        <h1 className='my-3 mt-9 fw-normal '>Job Requirements:</h1>

        <ul>
          <li>
            Bachelor’s/Master’s degree in Engineering, Computer Science (or equivalent experience)
          </li>
          <li>At least 5+ years of relevant experience in software development</li>
          <li>Extensive experience in Golang and other OOP languages</li>
          <li>
            Demonstrable experience with development across all application layers (data, business
            logic, and user interface development)
          </li>
          <li>Competent in working with Git and performing unit and integration testing</li>
          <li>Understanding of load and performance testing</li>
        </ul>
      </div>

      <div>
        <div className='fs-4 fw-normal text-gray-800 my-4 mt-9'>
          <span className='fs-3 fw-bold '> Skills and Expertise</span>
          <div className='row mt-3'>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-1 '>Node js</span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>React</span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>
                Ruby on Rails
              </span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>Node js</span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>Greaph QL</span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>
                Express JS
              </span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>Mongo DB</span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>GOlang</span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>Redis</span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>
                Redux-saga
              </span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>
                Redux thunk
              </span>
            </div>
            <div className='col-auto'>
              {' '}
              <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 '>Redux</span>
            </div>
          </div>
        </div>
      </div>

      <div className='separator separator-dashed border-gray-300 mt-8 mb-10'></div>
    </EnableSidebar>
  )
}

export default JobItem
